// extracted by mini-css-extract-plugin
module.exports = {"container":"style__container__r8Rc5","veryHigh":"style__veryHigh__8Fb7t","high":"style__high__nnc14","mid":"style__mid__UrtRM","average":"style__average__xrKF2"};